// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiWaveDecisionAward } from '../models/ApiWaveDecisionAward';
import { HttpFile } from '../http/http';

export class ApiDropWinningContext {
    'place': number;
    'awards': Array<ApiWaveDecisionAward>;
    'decision_time': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "place",
            "baseName": "place",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "awards",
            "baseName": "awards",
            "type": "Array<ApiWaveDecisionAward>",
            "format": ""
        },
        {
            "name": "decision_time",
            "baseName": "decision_time",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiDropWinningContext.attributeTypeMap;
    }

    public constructor() {
    }
}
